<template>
  <div class="navbar">
    <div class="header">
      <span class="hamburger-span">
        <Hamburger
          style="line-height: 0px"
          class="hamburger-container"
          :toggle-click="toggleSideBar"
          :is-active="true"
        />
      </span>
      <div class="headerRight">
        <el-dropdown
          trigger="click"
          placement="bottom"
          @command="onToolbarSelect"
        >
          <span
            class="el-dropdown-link el-icon-suitcase"
            style="
              color: #fff;
              font-size: 18px;
              margin-right: 15px;
              cursor: pointer;
            "
            title="工具箱"
          >
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="timestampConv">
              时间戳转换
            </el-dropdown-item>
            <!-- <el-dropdown-item command="sendRequest">
                            发送请求
                        </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>

        <div class="infor_div" @click="changeHome">
          <img
            src="../../../../assets/images/login/small_tong.png"
            class="infro_image"
          />
          <div v-if="numberCount > 0" class="isDot">
            {{ numberCount > 99 ? '99+' : numberCount }}
          </div>
        </div>
        <span class="welcome">欢迎用户</span>
        <span class="user">{{ this.getCookie('userName') }}</span>
        <el-dropdown
          class="avatar-container right-menu-item"
          trigger="click"
          placement="bottom"
        >
          <span class="el-dropdown-link">
            <i class="el-icon-switch-button" style="cursor: pointer"></i>
          </span>
          <el-dropdown-menu slot="dropdown" ref="dialogOut" class="dialogOut">
            <el-dropdown-item divided>
              <span style="display: block" class="logout" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <base-tool
      :visible.sync="tools.timestampConv"
      title="时间戳转换"
      :width="400"
    >
      <timestamp-conv />
    </base-tool>

    <!-- <base-tool :visible.sync="tools.sendRequest" title="发送请求" :width="600">
            <send-request></send-request>
        </base-tool> -->
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger'
import TimestampConv from './tools/TimestampConv.vue'
// import SendRequest from './tools/SendRequest.vue';
import BaseTool from './tools/BaseTool.vue'
export default {
  components: {
    Hamburger,
    TimestampConv,
    BaseTool,
    // SendRequest
  },
  data() {
    return {
      user: '',

      tools: {
        timestampConv: false,
        sendRequest: false,
      },
    }
  },

  computed: {
    numberCount() {
      return this.$store.state.common.numberCount
    },
  },
  watch: {
    numberCount(newVal) {
      console.log(newVal, 'newVal')
    },
  },
  methods: {
    logout() {
      this.$confirm("<div class='tesDiv'><div>确认退出吗</div></div>", '', {
        cancelButtonClass: 'btnCustomCencel',
        confirmButtonClass: 'btnCustomSubmit',
        customClass: 'customClass',
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$router.push({
            path: '/Login',
          })
        })
        .catch(() => {})
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    changeHome() {
      if (this.$route.path !== '/Home') {
        this.$router.push({
          path: '/Home',
        })
      }
    },

    onToolbarSelect(command) {
      if (command === 'timestampConv') {
        this.tools.timestampConv = true
      } else if (command === 'sendRequest') {
        this.tools.sendRequest = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-header {
  padding: 0 !important;
}

::v-deep.el-dropdown-menu__item--divided {
  border: 0;
  margin: 0px;
  padding: 0;
}

::v-deep.el-dropdown-menu__item--divided:before {
  margin: 0;
}

.header {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #3bafda;
  color: #fff;
  position: relative;
}

.headerLeft {
  display: inline-block;
}

.hamburger-span {
  float: left;
}

.hamburger-container {
  line-height: 60px !important;
}

.headerRight {
  position: absolute;
  right: 40px;
  color: #fff;
  display: flex;
  align-items: center;

  .infor_div {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }

  .infro_image {
    width: 17px;
    height: 17px;
    margin-right: 30px;
    margin-top: -2px;
  }

  .isDot {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #ff4848;
    border-radius: 50%;
    line-height: 20px;
    text-align: center;
    left: 10px;
    top: -7px;
    color: #fff;
    font-size: 11px;
  }

  .welcome {
    margin-right: 30px;
  }

  .user {
    margin-right: 30px;
  }
}

.logout {
  padding: 0 20px;
}
</style>
